
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.007 17.301c3.967 0 7.637 1.983 9.8 5.289.314.439.23 1.006-.15 1.304l-.111.074c-.42.35-1.048.22-1.398-.27-1.744-2.732-4.837-4.392-8.141-4.392-3.206 0-6.148 1.512-7.983 4.074l-.215.312c-.258.452-.814.604-1.216.365l-.105-.074c-.48-.274-.629-.893-.344-1.39 2.23-3.316 5.904-5.292 9.863-5.292zm0-12.301c3.108 0 5.608 2.5 5.608 5.608 0 3.109-2.5 5.608-5.608 5.608a5.594 5.594 0 01-5.608-5.608C8.399 7.5 10.899 5 14.007 5zm0 2.005a3.587 3.587 0 00-3.603 3.603c0 2.002 1.6 3.603 3.603 3.603 2.002 0 3.603-1.6 3.603-3.603a3.588 3.588 0 00-3.603-3.603z"}})])
          )
        }
      }
    